import { logUtil } from '../../logs'

function toIntNumberUtil (value) {
  if (!value) {
    return 0
  }

  let val = parseInt(value, 10)
  if (Number.isNaN(val)) {
    logUtil('toIntNumberUtil').warn('invalid value: ', value)
    val = 0
  }

  return val
}

export {
  toIntNumberUtil
}
